import { IRootState } from '../../reducer';

export const selectIsDailySeatModalOpen = (rootState: IRootState): boolean => {
  return rootState.modals.dailySeatModal.isOpen;
};
